<div class="select-object-type-button-container mat-form-field-wrapper">
  <button
    mat-stroked-button
    type="button"
    class="filter-selection-button"
    [matMenuTriggerFor]="objTypeFilterMenu"
    [disabled]="objectTypes.length === 0"
  >
    {{ buttonLabel | translate }}
  </button>

  <mat-menu #objTypeFilterMenu="matMenu">
    @for (group of objectTypes; track $index) {
      <ng-container>
        <button
          mat-menu-item
          type="button"
          [matMenuTriggerFor]="subMenu"
          (click)="toggleGroupSelection(group, $event)"
        >
          <mat-checkbox
            [checked]="objectTypeSelectionState.isGroupSelected(group.groupId)"
            [indeterminate]="objectTypeSelectionState.isGroupPartiallySelected(group.groupId)"
          ></mat-checkbox>

          {{ group.groupName | translate }}
        </button>

        <mat-menu #subMenu="matMenu">
          @for (option of group.options; track $index) {
            <button
              mat-menu-item
              type="button"
              (click)="toggleOptionSelection(option, $event)"
            >
              <mat-checkbox
                [checked]="objectTypeSelectionState.isOptionSelected(group.groupId, option.id)"
              ></mat-checkbox>

              {{ option.name | translate }}
            </button>
          }
        </mat-menu>
      </ng-container>
    }
  </mat-menu>

  <mat-chip-listbox class="chip-list" [selectable]="false">
    @for (opt of objectTypeSelectionState.getSelectedOptions(); track $index) {
      <mat-chip-option
        class="chip"
        [selectable]="false"
        (removed)="toggleOptionSelection(opt)"
        removable
      >
        {{ opt.name | translate }}

        <mat-icon matChipRemove>
          cancel
        </mat-icon>
      </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
